import React from 'react';
import { P1 } from 'pfm-ui-components';

const twoFactorNoResponseInfo = () => {
  
  return (
    <React.Fragment>
      <P1>
      Dear Customer, as per the latest SEBI guidelines on enhancing security of MF transactions a new two-factor Authentication (2FA) process has come into effect from 1st April'23. At the time of executing a transaction, an OTP is sent to your mobile no & email id registered with the Bank, however as per the circular, if there is a mismatch between the mobile number & email id registered with the Bank and that with the AMC, such transactions will get rejected.
      </P1>
      <br />
      <P1>
      In this context, we are currently facing a technical error while fetching contact details from the AMC. Please try again later. Regret the inconvenience.
      </P1>
      <br/>
    </React.Fragment>
  );
};

export default twoFactorNoResponseInfo;